import { useAccount } from 'reservations/account/providers/AccountProvider';

export const useLogo = () => {
  const { logo, brandLogo } = useAccount();

  return brandLogo?.url ? brandLogo : logo;
};
